/* eslint-disable import/no-anonymous-default-export */
export function close() {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(JSON.stringify({ type: "PHZ_GO_BACK" }));
}
export function openNewWebview(name, link) {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_OPEN_NEW_WEBVIEW",
          data: { link: link, name: name },
        })
      );
}
export function openBrowser(link) {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_OPEN_BROWSER",
          data: { link: link },
        })
      );
}
export function makePayment(data) {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PAYMENT_HUB_TRANSACTION",
          data: data,
        })
      );
}
export function openTel(phoneNumber) {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_OPEN_TEL",
          data: { phoneNumber: phoneNumber },
        })
      );
}
export function requestLocationPermission(handler) {
  var _a;
  setOnPermissionResult(handler);
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_REQUEST_LOCATION_PERMISSION",
        })
      );
}
export function requestCameraPermission(handler) {
  var _a;
  setOnPermissionResult(handler);
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_REQUEST_CAMERA_PERMISSION",
        })
      );
}
export function requestPhotoPermission(handler) {
  var _a;
  setOnPermissionResult(handler);
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_REQUEST_PHOTO_PERMISSION",
        })
      );
}
export function addGoHomeListener(handler) {
  window.onGoHome = handler;
}
export function keepSession() {
  var _a;
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_KEEP_SESSION",
        })
      );
}
export function setOnPermissionResult(handler) {
  window.onPermissionResult = handler;
}
export function setCallbackResult(handler) {
  window.onCallback = handler;
}
export function selectContact(handler) {
  var _a;
  setCallbackResult(handler);
  (_a = window.miniApp) === null || _a === void 0
    ? void 0
    : _a.postMessage(
        JSON.stringify({
          type: "PHZ_SELECT_CONTACT",
        })
      );
}
export default {
  close,
  openBrowser,
  openNewWebview,
  makePayment,
  openTel,
  requestLocationPermission,
  requestCameraPermission,
  requestPhotoPermission,
  keepSession,
  addGoHomeListener,
  selectContact,
};
